module.exports = "../static/media/banner.5e6c18d5.png";